import { useContext, useState } from 'react';
import { LocaleContext } from './localeContextValue';
import { getActiveLocale, setGuestLocale } from '../i18n';

export function useLocale() {
  const context = useContext(LocaleContext);
  if (!context) {
    throw new Error('useLocale must be used within a LocaleProvider');
  }
  return context;
}

export function useOptionalLocale() {
  const context = useContext(LocaleContext);
  const [fallbackLocale, setFallbackLocale] = useState(getActiveLocale);

  if (context) return context;

  return {
    locale: fallbackLocale,
    setLocale: (locale: Parameters<typeof setGuestLocale>[0]) => {
      setGuestLocale(locale);
      setFallbackLocale(locale);
    },
  };
}
